import Vue from 'vue' 
export const alertBus = new Vue()